import { camelizeString } from "./string";

export const getRoleIds = roles => {
  const ids = {};
  if (roles) {
    roles.forEach(element => {
      ids[camelizeString(element.name)] = element.id;
    });
  }

  return ids;
};
